import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../config.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { ExceptionHandlingService } from '../../shared/exception-handling.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { finalize } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';


@Component({
  selector: 'app-change-testing-location',
  templateUrl: './change-testing-location.component.html',
  styleUrls: ['./change-testing-location.component.scss'],
})

export class ChangeTestingLocationComponent implements OnInit {

  error: any = {};
  isLoading: boolean = false;
  userInfo: any = {}
  transfer: any = {
    selectionYear: null
  };
  currentYear: any = "";

  constructor(
    private appConstants: AppConstants,
    public translate: TranslateService,
    private service: SharedService,
    private keycloakService: KeycloakService,
    public toastr: ToastService,
    private errorService: ExceptionHandlingService,
  ) {
  }
  
   ngOnInit() {
      const user = this.appConstants.userDetails
      this.userInfo = user
      let currentYear = new Date().getFullYear();
      this.currentYear = currentYear - 1;
      this.transfer.selectionYear = null;
      this.setUI();
      window.onresize = () => {
        setTimeout(() => { this.setUI() }, 200);
      }
    }
   


  setUI() {
    let h = window.innerHeight;
    let uiInterval = setInterval(() => {
      if (document.getElementById('components-container')) {
        document.getElementById('components-container').style.maxHeight = (h - 270) + "px"
        clearInterval(uiInterval)
      }
    }, 100)
  }

  allStatuses: any = [];
  allStatusesLoading: boolean = false;
  getAllStatuses() {
    this.allStatuses = [];
    const url = this.appConstants.endPoints.certificatesEndPoint + 'options/workflow-definition-states';
    this.allStatusesLoading = true;
    this.service.get(url, {})
      .pipe(finalize(() => {
        this.allStatusesLoading = false;
      }))
      .subscribe(data => {
        if (data) {
          this.allStatuses = data;
          this.allStatuses = this.allStatuses.map(res => { return { id: res.id, name: res.name } })
        }
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }

  fromTestLocation: any = null;
  fromTestLocations: any = [];
  fromTestLocationsLoading: boolean = false;
  getFromTestLocations() {
    this.fromTestLocations = [];
    this.fromTestLocationsLoading = true;
    let url = this.appConstants.endPoints.certificatesEndPoint + 'options/component-test-locations'
    this.service
      .post(url, {}, {})
      .pipe(finalize(() => {
        this.fromTestLocationsLoading = false;
      }))
      .subscribe(data => {
        this.fromTestLocations = data.searchResults
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }
  fromTestLocationChanged(e) {
    this.toTestLocation = null
    this.fromTestLocation = e;
  }
  toTestLocation: any = null;
  toTestLocations: any = [];
  toTestLocationsLoading: boolean = false;
  getToTestLocations() {
    this.toTestLocations = [];
    this.toTestLocationsLoading = true;
    let url = this.appConstants.endPoints.certificatesEndPoint + 'options/component-test-locations'
    this.service
      .post(url, {}, {})
      .pipe(finalize(() => {
        this.toTestLocationsLoading = false;
      }))
      .subscribe(data => {
        this.toTestLocations = data.searchResults
        // remove selected from testing location
        let index = this.toTestLocations.findIndex((o) => {
          return o.id == this.fromTestLocation.id;
        })
        if (index !== -1) { this.toTestLocations.splice(index, 1) };
        //
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }

  resetPagingInfo() {
    this.pageInfo.currentPage = 1;
    this.pageInfo.disablePagination = true;
    this.pageInfo.totalItems = 0;
    this.impactedComponents = []
  }


  impactedComponents: any = [];
  impactedComponentsLoading: boolean = false;
  showComponentsImpacted() {
    this.impactedComponents = [];
    let bodyPayload = {};
    bodyPayload['pageNumber'] = this.pageInfo.currentPage
    bodyPayload['pageSize'] = this.pageInfo.itemsPerPage
    bodyPayload['isPaging'] = true
    bodyPayload['selectionYear'] = (this.transfer.selectionYear).getFullYear();

    if (this.transfer && this.transfer.fromTestLocation && this.transfer.fromTestLocation.id)
      bodyPayload['testingLocationId'] = this.transfer.fromTestLocation.id

    if (this.transfer && this.transfer.status && this.transfer.status.id)
      bodyPayload['stateId'] = this.transfer.status.id

    this.impactedComponentsLoading = true;
    let url = this.appConstants.endPoints.certificatesEndPoint + 'critical-components/query-components'
    this.service.post(url, {}, bodyPayload)
      .pipe(finalize(() => {
        this.impactedComponentsLoading = false;
      }))
      .subscribe(data => {
        this.impactedComponents = data && data.searchResults ? data.searchResults : [];
        if (data && data.pagingInfo && typeof data.pagingInfo == "object") {
          this.pageInfo.totalItems = data.pagingInfo.totalRows;
          this.pageInfo.disablePagination = false;
          let paginationProperty = data.pagingInfo
          const totalItemsFound = this.translate.instant("administration_totalItemsFound_label");
          const displayingItems = this.translate.instant('administration_displayingItems_label');
          const totalPages = this.translate.instant('administration_totalPages_label');;
          const paginationMessage = totalItemsFound + paginationProperty.totalRows + " | " +
            displayingItems + " " + paginationProperty.startingOffset + " - " + paginationProperty.endingOffset + " | " +
            totalPages + paginationProperty.totalPages;
          this.paginationMessage = paginationMessage
        } else {
          this.pageInfo.disablePagination = true;
          const totalItemsFound = this.translate.instant("administration_totalItemsFound_label");
          this.paginationMessage = totalItemsFound + this.impactedComponents.length;
        }
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }

  pageInfo = {
    id: 'components-change-testing-pagination',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 0,
    disablePagination: false
  };

  paginationMessage: string;
  paginationChange(event) {
    this.pageInfo.currentPage = event
    this.pageInfo.disablePagination = true;
    this.pageInfo.totalItems = 0;
    this.impactedComponents = [];
    this.showComponentsImpacted();
  }

  changeLocation() {
    let url = this.appConstants.endPoints.certificatesEndPoint + 'tools/components/change-locations'
    this.service.post(url, {}, {
      "selectionYear": (this.transfer.selectionYear).getFullYear(),
      "fromTestingLocationId": this.transfer.fromTestLocation.id,
      "toTestingLocationId": this.transfer.toTestLocation.id
    })
      .pipe(finalize(() => {
        this.impactedComponentsLoading = false;
      }))
      .subscribe(data => {
        this.transfer.fromTestLocation = this.transfer.toTestLocation;
        this.transfer.toTestLocation = null
        this.showComponentsImpacted();
        this.toastr.success(this.translate.instant('administration_transferCompleted_label'));
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }

}
